/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Field_Company_PlaceholderInputs */

const en_contact_field_company_placeholder = /** @type {(inputs: Contact_Field_Company_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where you work`)
};

/**
* | output |
* | --- |
* | "Where you work" |
*
* @param {Contact_Field_Company_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_field_company_placeholder = /** @type {((inputs?: Contact_Field_Company_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Field_Company_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_field_company_placeholder(inputs)
});